import axios from '@/server/request'

const state = {
    mediaData: {},
    isMediaLoading: false
}

const mutations = {
    updateMediaData(state, payload) {
        state.mediaData = null
        state.mediaData = payload
    },

    updateMediaLoading(state, payload) {
        state.isMediaLoading = payload
    }
}

const actions = {
    // 添加订阅
    async fetchMediaList({ commit }, params) {
        commit('updateMediaLoading', true)
        try {
            const res = await axios.post({
                url: 'search/discoverGoodMedia',
                params
            })

            if (res.data.ErrorCode === 200) {
                commit('updateMediaLoading', false)
                commit('updateMediaData', res.data.Data)
                return Promise.resolve(res.data.Data)
            }
        } catch (errMsg) {
            console.error(errMsg)
            commit('updateMediaLoading', false)
        }
    }
}

export default {
    namespaced: true,
    state,
    getters: {},
    mutations,
    actions
}
